import PolicyListComponents from "../components/PolicyList";
import usePolicyListProps from "../hook/usePolicyList";

const PolicyList = () => {
  const policyListProps = usePolicyListProps();
  return <PolicyListComponents {...policyListProps} />;
};

export default PolicyList;
